import { Col, Row } from "antd";
import { useRouteMatch } from "react-router";
import { Box, Flex } from "@chakra-ui/layout";

import { useBreadcrumb } from "features/breadcrumbs";

import { showSuccess } from "infra/helpers/alerta";
import { useState } from "react";
import MenuDetalhes from "components/Menu/MenuDetalhes";
import { TabMenuOptions, TabsMenuOptionsRoutes } from "./typings";
import history from "infra/helpers/history";
import CardDefault from "components/Cards/CardDefault";
import DadosCadastrais from "./components/DadosCadastrais";
import { useLocation } from "react-router-dom";
import PageHeader from "components/Page/PageHeader";
import { BsBank } from "react-icons/bs";
import Disponibilidade from "./components/Disponibilidade";
import BloqueioDatas from "./components/BloqueioDatas";
import TaxasUso from "./components/TaxasUso";
import Fotos from "./components/Fotos";
import Container from "components/Container";
import RegrasReserva from "./components/RegrasReserva/index";
import AreaComunVinculada from "./components/AreaComunVinculada/index";
import useFindAreaComum from "core/features/area-comum/hooks/useFindAreaComum";
import { useCurrentTenant } from "core/features/auth/tenant.store";

function AreaComumDetalhesPage() {
  const route = useRouteMatch<{ id: string; tenant: string }>();
  const { tenant } = useCurrentTenant();

  const { data: areaComum } = useFindAreaComum(tenant.id, route.params.id);

  const getBreadcrumb = () => {
    if (areaComum) return areaComum.nome;
    if (route.params.id) return "Editar área comum";

    return "Nova área comum";
  };

  useBreadcrumb([
    { name: "Cadastros", url: "/cadastros" },
    { name: "Áreas comuns", url: "/cadastros/areas-comum" },
    {
      name: getBreadcrumb(),
    },
  ]);

  const { search } = useLocation();

  const params = new URLSearchParams(search);
  const opcaoParam = !route.params.id
    ? TabsMenuOptionsRoutes.Dados
    : (params.get("opcao") as string) || TabsMenuOptionsRoutes.Dados;

  const [selectedMenuOption, setSelectedMenuOption] = useState(opcaoParam);

  const handleChangeMenu = (tab: string) => {
    setSelectedMenuOption(tab);

    if (route.params.id) {
      history.push(`/cadastros/areas-comum/${route.params.id}?opcao=${tab}`);
    } else {
      history.push(`/cadastros/areas-comum/new?opcao=${tab}`);
    }
  };

  if (!opcaoParam) {
    return null;
  }

  return (
    <Container pb="32px">
      <PageHeader
        title={
          route.params?.id ? (
            <Flex gap="8px" fontWeight="bold">
              <BsBank />
              Editar área comum {areaComum ? " - " + areaComum.nome : null}
            </Flex>
          ) : (
            "Criar área comum"
          )
        }
      />

      <Row gutter={32}>
        <Col sm={6}>
          <Box mb={4} pt="0px" flex={1}>
            <MenuDetalhes<TabsMenuOptionsRoutes>
              disabledOptions={
                !route.params.id
                  ? [
                      TabsMenuOptionsRoutes.Disponibilidade,
                      TabsMenuOptionsRoutes.Taxas,
                      TabsMenuOptionsRoutes.Fotos,
                      TabsMenuOptionsRoutes.BloqueioDatas,
                      TabsMenuOptionsRoutes.AreasComumsVinculadas,
                    ]
                  : []
              }
              options={TabMenuOptions}
              selectedOption={selectedMenuOption as TabsMenuOptionsRoutes}
              onChangeOption={(tab) => {
                handleChangeMenu(tab);
              }}
            />
          </Box>
        </Col>

        <Col sm={18}>
          {selectedMenuOption === TabsMenuOptionsRoutes.Dados ? (
            <CardDefault>
              <DadosCadastrais
                onSaved={(id) => {
                  showSuccess().then(() => {
                    if (route.params.id) {
                      history.push(`/cadastros/areas-comum/${id}`);
                    } else {
                      history.push(
                        `/cadastros/areas-comum/${id}?opcao=${TabsMenuOptionsRoutes.Disponibilidade}`
                      );
                    }
                  });
                }}
                id={route.params.id}
              />
            </CardDefault>
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.Disponibilidade ? (
            <CardDefault>
              <Disponibilidade id={route.params.id} />
            </CardDefault>
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.RegrasReserva ? (
            <RegrasReserva id={route.params.id} />
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.Taxas ? (
            <CardDefault>
              <TaxasUso id={route.params.id} />
            </CardDefault>
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.Fotos ? (
            <CardDefault>
              <Fotos id={route.params.id} />
            </CardDefault>
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.BloqueioDatas ? (
            <CardDefault>
              <BloqueioDatas id={route.params.id} />
            </CardDefault>
          ) : null}

          {selectedMenuOption ===
          TabsMenuOptionsRoutes.AreasComumsVinculadas ? (
            <CardDefault>
              <AreaComunVinculada id={route.params.id} />
            </CardDefault>
          ) : null}

          {/* {selectedMenuOption === TabsMenuOptionsRoutes.Disponibilidade ? (
              <TabelaPessoas unidadeId={route.params.id} />
            ) : null}

            {selectedMenuOption === TabsMenuOptionsRoutes.Taxas ? (
              <TabelaVeiculos unidadeId={route.params.id} />
            ) : null} */}
        </Col>
      </Row>
    </Container>
  );
}

export default AreaComumDetalhesPage;
